<template>
  <div class="return-order-mgmt purchase-mgmt-page">
    <!-- <div class="section-card">
      <div class="section-title">导入退货订单</div>
      <div class="upload-row">
        <span class="label">退货报告 CSV</span>
        <el-upload ref="uploadReturnOrder" class="upload-inline" action="/node/importReturnOrder" :data="{ shopType }" :auto-upload="false" :limit="1" accept=".csv,.txt" :on-success="onUploadSuccess" :on-error="onUploadError">
          <el-button size="small">选取文件</el-button>
        </el-upload>
        <el-button type="primary" size="small" :loading="importing" @click="onImportSubmit">导入</el-button>
        <span class="hint">字段：return-date / order-id / sku / asin / fnsku / product-name / quantity 等</span>
      </div>
    </div> -->

    <div class="page-header">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select v-model="params.productType" placeholder="全部" size="small" clearable filterable class="filter-select-wide">
              <el-option v-for="product in productList" :key="product.productType" :label="product.productName" :value="product.productType" />
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">颜色</span>
            <el-select v-model="params.productColor" placeholder="全部" size="small" clearable>
              <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key" />
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">型号</span>
            <el-select v-model="params.model" placeholder="全部" size="small" clearable filterable>
              <el-option v-for="item in modelList" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">订单号</span>
            <el-input v-model="params.orderId" size="small" clearable placeholder="订单号" class="filter-input-wide" @keyup.enter.native="onQueryClick" />
          </div>
          <div class="filter-item">
            <span class="filter-label">ASIN</span>
            <el-input v-model="params.asin" size="small" clearable placeholder="asin" @keyup.enter.native="onQueryClick" />
          </div>
          <div class="filter-item">
            <span class="filter-label">SKU</span>
            <el-input v-model="params.sku" size="small" clearable placeholder="sku" class="filter-input-wide" @keyup.enter.native="onQueryClick" />
          </div>
          <div class="filter-item">
            <span class="filter-label">退货原因</span>
            <el-select v-model="params.reason" placeholder="全部" size="small" clearable filterable class="filter-select-xl">
              <el-option v-for="item in reasonOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">处置详情</span>
            <el-select v-model="params.detailedDisposition" placeholder="全部" size="small" clearable filterable>
              <el-option v-for="item in detailedDispositionOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">退货处理结果</span>
            <el-select v-model="params.status" placeholder="全部" size="small" clearable filterable class="filter-select-xl">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="onQueryClick">查询</el-button>
            <el-button type="primary" size="small" plain @click="onExportBtnClick">导出</el-button>
            <el-button size="small" icon="el-icon-data-analysis" @click="goReturnOrderAnalysis">退货订单分析</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="导出退货订单" :visible.sync="dialogExportVisible" width="900px" :close-on-click-modal="false">
      <div class="export-filter-row">
        <div class="filter-item">
          <span class="filter-label">退货日期</span>
          <el-date-picker
            v-model="exportDateRange"
            type="daterange"
            size="small"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 260px"
          />
        </div>
        <div class="filter-item">
          <span class="filter-label">产品类型</span>
          <el-select v-model="exportParams.productType" placeholder="全部" size="small" clearable filterable style="width: 150px">
            <el-option v-for="product in productList" :key="'export-' + product.productType" :label="product.productName" :value="product.productType" />
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-label">颜色</span>
          <el-select v-model="exportParams.productColor" placeholder="全部" size="small" clearable style="width: 120px">
            <el-option v-for="color in exportColorList" :key="'export-color-' + color.key" :label="color.name" :value="color.key" />
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-label">型号</span>
          <el-select v-model="exportParams.model" placeholder="全部" size="small" clearable filterable style="width: 130px">
            <el-option v-for="item in exportModelList" :key="'export-model-' + item" :label="item" :value="item" />
          </el-select>
        </div>
        <el-button type="primary" size="small" :loading="exportLoading" @click="loadExportList">查询</el-button>
      </div>
      <el-table :data="exportDataList" border stripe size="mini" max-height="420" v-loading="exportLoading" element-loading-text="加载中...">
        <el-table-column label="序号" width="55" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="shopName" label="店铺" width="90" show-overflow-tooltip />
        <el-table-column prop="orderId" label="订单号" width="170" show-overflow-tooltip />
        <el-table-column prop="productName" label="产品名称" width="120" show-overflow-tooltip />
        <el-table-column prop="productColorName" label="颜色" width="80" show-overflow-tooltip />
        <el-table-column prop="model" label="型号" width="90" show-overflow-tooltip />
        <el-table-column prop="sku" label="SKU" width="220" show-overflow-tooltip />
        <el-table-column prop="asin" label="ASIN" width="120" show-overflow-tooltip />
        <el-table-column prop="detailedDisposition" label="处置详情" width="110" show-overflow-tooltip />
        <el-table-column prop="status" label="退货处理结果" width="120" show-overflow-tooltip />
        <el-table-column prop="reason" label="退货原因" width="140" show-overflow-tooltip />
        <el-table-column prop="returnDate" label="退货日期" width="110" show-overflow-tooltip />
        <el-table-column prop="customerComments" label="客户备注" min-width="140" show-overflow-tooltip />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <span class="export-total-tip">共 {{ exportDataList.length }} 条</span>
        <el-button size="small" @click="dialogExportVisible = false">关 闭</el-button>
        <el-button class="opreate-btn" type="primary" size="small" :disabled="!exportDataList.length">
          <download-excel :data="exportDataList" :fields="exportTitles" :name="getExportName()">导出</download-excel>
        </el-button>
      </div>
    </el-dialog>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table
          :data="tableData"
          border
          stripe
          size="small"
          :height="screenHeight"
          header-cell-class-name="table-header-cell"
          class="mgmt-table"
          style="width: 100%"
        >
          <el-table-column label="序号" width="55" align="center" fixed>
            <template slot-scope="scope">{{ params.beginIndex + scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="shopName" label="店铺" width="90" show-overflow-tooltip />
          <el-table-column label="订单号" width="170" show-overflow-tooltip>
            <template slot-scope="scope">{{ getOrderId(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" width="120" show-overflow-tooltip />
          <el-table-column prop="productColorName" label="颜色" width="80" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.productColorName || scope.row.productColor || "—" }}</template>
          </el-table-column>
          <el-table-column prop="model" label="型号" width="90" show-overflow-tooltip />
          <el-table-column prop="sku" label="SKU" width="300" show-overflow-tooltip />
          <el-table-column prop="asin" label="ASIN" width="120" show-overflow-tooltip />
          <el-table-column prop="detailed-disposition" label="处置详情" width="110" show-overflow-tooltip>
            <template slot-scope="scope">{{ translateDetailedDisposition(scope.row["detailed-disposition"]) }}</template>
          </el-table-column>
          <el-table-column prop="status" label="退货处理结果" width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ translateStatus(scope.row.status) }}</template>
          </el-table-column>
          <el-table-column prop="reason" label="退货原因" width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ translateReason(scope.row.reason) }}</template>
          </el-table-column>
          <el-table-column prop="returnDate" label="退货日期" width="110" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.returnDate || scope.row["return-date"] || "—" }}</template>
          </el-table-column>
          <el-table-column prop="customer-comments" label="客户备注" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row["customer-comments"] || "—" }}</template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-box">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 200]"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          :total="totalRecords"
          @size-change="onPageSizeChange"
          @current-change="loadList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { activeProducts, colors, models } from "../../utils/constant.js";

const DETAILED_DISPOSITION_MAP = {
  CARRIER_DAMAGED: "承运商损坏",
  CUSTOMER_DAMAGED: "客户损坏",
  DAMAGED: "商品损坏",
  DEFECTIVE: "商品有缺陷",
  SELLABLE: "可销售",
};

const STATUS_MAP = {
  IMMEDIATE_DONATION: "立即捐赠",
  IMMEDIATE_LIQUIDATION: "立即清算",
  Reimbursed: "已赔付",
  "Unit returned to inventory": "已退回库存",
  Active: "有效",
  Inactive: "无效",
};

const REASON_MAP = {
  APPAREL_TOO_LARGE: "服装尺码太大",
  APPAREL_TOO_SMALL: "服装尺码太小",
  DAMAGED_BY_CARRIER: "承运商造成损坏",
  DAMAGED_BY_FC: "亚马逊仓库造成损坏",
  DEFECTIVE: "商品有缺陷",
  FOUND_BETTER_PRICE: "找到更低价格",
  MISSED_ESTIMATED_DELIVERY: "未按预计时间送达",
  MISSING_PARTS: "缺少配件",
  NEVER_ARRIVED: "从未收到商品",
  NO_REASON_GIVEN: "未提供退货原因",
  NOT_AS_DESCRIBED: "与商品描述不符",
  NOT_COMPATIBLE: "不兼容",
  ORDERED_WRONG_ITEM: "买错商品",
  QUALITY_UNACCEPTABLE: "质量无法接受",
  SWITCHEROO: "调包/掉包",
  UNAUTHORIZED_PURCHASE: "未经授权购买",
  UNDELIVERABLE_UNKNOWN: "无法配送，原因未知",
  UNWANTED_ITEM: "不想要了",
};

/** 兼容历史/不规范写法到标准 Code */
const STATUS_ALIASES = {
  active: "Active",
  actived: "Active",
  inactive: "Inactive",
};

function mapToOptions(map) {
  return Object.keys(map).map(value => ({ value, label: map[value] }));
}

function resolveCode(map, code, aliases) {
  const key = String(code).trim();
  if (map[key]) {
    return key;
  }
  const lower = key.toLowerCase();
  if (aliases && aliases[lower] && map[aliases[lower]]) {
    return aliases[lower];
  }
  const matched = Object.keys(map).find(k => k.toLowerCase() === lower);
  return matched || key;
}

function translateCode(map, code, emptyText = "—", aliases) {
  if (code === undefined || code === null || code === "") {
    return emptyText;
  }
  const resolved = resolveCode(map, code, aliases);
  return map[resolved] || resolved;
}

export default {
  name: "ReturnOrderMgmt",
  data() {
    return {
      shopType: localStorage.getItem("shopType") || "",
      importing: false,
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      detailedDispositionOptions: mapToOptions(DETAILED_DISPOSITION_MAP),
      statusOptions: mapToOptions(STATUS_MAP),
      reasonOptions: mapToOptions(REASON_MAP),
      params: {
        productType: "",
        productColor: "",
        model: "",
        asin: "",
        sku: "",
        orderId: "",
        reason: "",
        detailedDisposition: "",
        status: "",
        beginIndex: 0,
        pageSize: 50,
      },
      tableData: [],
      currentPage: 1,
      pageSize: 50,
      totalRecords: 0,
      screenHeight: 400,
      dialogExportVisible: false,
      exportLoading: false,
      exportDateRange: [],
      exportParams: {
        productType: "",
        productColor: "",
        model: "",
      },
      exportColorList: colors,
      exportModelList: models,
      exportDataList: [],
    };
  },
  watch: {
    "params.productType": {
      handler(newValue) {
        if (!newValue) {
          this.colorList = colors;
          this.modelList = models;
          return;
        }
        const parentProduct = this.productList.find(pd => pd.productType == newValue);
        if (!parentProduct) {
          return;
        }
        const checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors || "[]");
        const checkModels = JSON.parse(parentProduct.checkModels || "[]");
        this.colorList = [];
        this.modelList = [...checkModels];
        colors.forEach(color => checkColors.includes(color.key) && this.colorList.push(color));
        this.params.productColor = "";
        this.params.model = "";
      },
    },
    "exportParams.productType": {
      handler(newValue) {
        if (!newValue) {
          this.exportColorList = colors;
          this.exportModelList = models;
          return;
        }
        const parentProduct = this.productList.find(pd => pd.productType == newValue);
        if (!parentProduct) {
          return;
        }
        const checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors || "[]");
        const checkModels = JSON.parse(parentProduct.checkModels || "[]");
        this.exportColorList = [];
        this.exportModelList = [...checkModels];
        colors.forEach(color => checkColors.includes(color.key) && this.exportColorList.push(color));
        this.exportParams.productColor = "";
        this.exportParams.model = "";
      },
    },
  },
  activated() {
    this.$nextTick(() => {
      this.calculateHeight();
      this.loadList();
    });
  },
  mounted() {
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  computed: {
    exportTitles() {
      return {
        店铺: "shopName",
        订单号: "orderId",
        产品名称: "productName",
        颜色: "productColorName",
        型号: "model",
        SKU: "sku",
        ASIN: "asin",
        处置详情: "detailedDisposition",
        退货处理结果: "status",
        退货原因: "reason",
        退货日期: "returnDate",
        客户备注: "customerComments",
      };
    },
  },
  methods: {
    goReturnOrderAnalysis() {
      this.$router.push({ path: "/client/returnOrderAnalysis", query: { days: 90 } });
    },
    translateDetailedDisposition(code, emptyText) {
      return translateCode(DETAILED_DISPOSITION_MAP, code, emptyText);
    },
    translateStatus(code, emptyText) {
      return translateCode(STATUS_MAP, code, emptyText, STATUS_ALIASES);
    },
    translateReason(code, emptyText) {
      return translateCode(REASON_MAP, code, emptyText);
    },
    getOrderId(row) {
      return (row && (row["amazon-order-id"] || row["order-id"])) || "—";
    },
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const gap = 4;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - gap;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    onImportSubmit() {
      if (!this.$refs.uploadReturnOrder || this.$refs.uploadReturnOrder.uploadFiles.length === 0) {
        this.$message.warning("请先选择退货订单 CSV 文件");
        return;
      }
      this.importing = true;
      this.$refs.uploadReturnOrder.submit();
    },
    onUploadSuccess(res) {
      this.importing = false;
      if (res.code !== 0) {
        this.$message.error((res && res.message) || "导入失败");
        return;
      }
      this.$message.success("导入成功");
      this.$refs.uploadReturnOrder.clearFiles();
      this.currentPage = 1;
      this.loadList();
    },
    onUploadError() {
      this.importing = false;
      this.$message.error("导入失败");
    },
    onQueryClick() {
      this.currentPage = 1;
      this.loadList();
    },
    onPageSizeChange() {
      this.currentPage = 1;
      this.params.pageSize = this.pageSize;
      this.loadList();
    },
    buildQueryParams() {
      const query = {
        beginIndex: (this.currentPage - 1) * this.pageSize,
        pageSize: this.pageSize,
      };
      if (this.params.productType) {
        query.productType = this.params.productType;
      }
      if (this.params.productColor) {
        query.productColor = this.params.productColor;
      }
      if (this.params.model) {
        query.model = this.params.model;
      }
      if (this.params.asin) {
        query.asin = this.params.asin.trim();
      }
      if (this.params.sku) {
        query.sku = this.params.sku.trim();
      }
      if (this.params.orderId) {
        query.orderId = this.params.orderId.trim();
      }
      if (this.params.reason) {
        query.reason = this.params.reason;
      }
      if (this.params.detailedDisposition) {
        query["detailed-disposition"] = this.params.detailedDisposition;
      }
      if (this.params.status) {
        query.status = this.params.status;
      }
      return query;
    },
    loadList() {
      this.params.beginIndex = (this.currentPage - 1) * this.pageSize;
      this.params.pageSize = this.pageSize;
      requestModules.fetchReturnOrders(this.buildQueryParams()).then(res => {
        if (res.code !== 0) {
          this.$message.error((res && res.message) || "查询失败");
          return;
        }
        this.tableData = res.ldata || [];
        this.totalRecords = res.total || 0;
      }).finally(() => {
        this.calculateHeight();
      });
    },
    onExportBtnClick() {
      this.dialogExportVisible = true;
      this.exportDateRange = [];
      this.exportParams = {
        productType: "",
        productColor: "",
        model: "",
      };
      this.exportColorList = colors;
      this.exportModelList = models;
      this.exportDataList = [];
    },
    buildExportQueryParams() {
      if (!this.exportDateRange || this.exportDateRange.length !== 2 || !this.exportDateRange[0] || !this.exportDateRange[1]) {
        this.$message.warning("请选择退货日期范围");
        return null;
      }
      const query = {
        beginIndex: 0,
        pageSize: 20000,
        beginDate: this.exportDateRange[0],
        endDate: this.exportDateRange[1],
      };
      if (this.exportParams.productType) {
        query.productType = this.exportParams.productType;
      }
      if (this.exportParams.productColor) {
        query.productColor = this.exportParams.productColor;
      }
      if (this.exportParams.model) {
        query.model = this.exportParams.model;
      }
      return query;
    },
    normalizeExportRow(row) {
      const orderId = row["amazon-order-id"] || row["order-id"] || "";
      return {
        shopName: row.shopName || "",
        orderId,
        productName: row.productName || "",
        productColorName: row.productColorName || row.productColor || "",
        model: row.model || "",
        sku: row.sku || "",
        asin: row.asin || "",
        detailedDisposition: this.translateDetailedDisposition(row["detailed-disposition"], ""),
        status: this.translateStatus(row.status, ""),
        reason: this.translateReason(row.reason, ""),
        returnDate: row.returnDate || row["return-date"] || "",
        customerComments: row["customer-comments"] || "",
      };
    },
    loadExportList() {
      const query = this.buildExportQueryParams();
      if (!query) {
        return;
      }
      this.exportLoading = true;
      this.exportDataList = [];
      requestModules
        .fetchReturnOrders(query)
        .then(res => {
          if (res.code !== 0) {
            this.$message.error((res && res.message) || "导出查询失败");
            return;
          }
          const list = res.ldata || [];
          this.exportDataList = list.map(row => this.normalizeExportRow(row));
          if ((res.total || 0) > query.pageSize) {
            this.$message.warning(`匹配 ${res.total} 条，本次最多导出前 ${query.pageSize} 条，请缩小日期范围`);
          }
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    getExportName() {
      const range =
        this.exportDateRange && this.exportDateRange.length === 2
          ? `${this.exportDateRange[0]}_${this.exportDateRange[1]}`
          : new Date().toISOString().slice(0, 10);
      return `退货订单_${range}`;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

.return-order-mgmt {
  .filter-item {
    .el-select,
    .el-input {
      width: 140px;
    }

    .filter-select-wide {
      width: 160px !important;

      .el-input {
        width: 160px;
      }
    }

    .filter-select-xl {
      width: 180px !important;

      .el-input {
        width: 180px;
      }
    }

    .filter-input-wide {
      width: 160px;
    }
  }

  .filter-actions {
    margin-bottom: 4px;
  }

  .export-filter-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 16px;
    margin-bottom: 12px;

    .filter-item {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 0;

      .filter-label {
        flex-shrink: 0;
        color: #606266;
        font-size: 13px;
        white-space: nowrap;
      }
    }
  }

  .export-total-tip {
    float: left;
    line-height: 32px;
    font-size: 13px;
    color: #606266;
  }
}
</style>
